<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Raw Material Supplier Wise Cost Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="selectedVendor.v_name ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("vendor") }}</label
              >
              <multiselect
                :options="vendorsData"
                v-model="selectedVendor"
                :searchable="true"
                label="v_name"
                track-by="v_id"
                placeholder="Select Vendor"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getRawMaterialsCostReport((isExcel = 'N'))"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="rawMaterialCostRecords.length > 0"
            class="col-lg-6 col-xl-3 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              href="#"
              @click="getRawMaterialsCostReport((isExcel = 'Y'))"
              title="Download as Excel"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        style="overflow-x:scroll;width: auto !important"
        v-if="rawMaterialCostRecords.length > 0"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <tr class="bg-lightgrey font-weight-bold">
            <!-- <th>Book Name</th> -->
            <th>Branch</th>
            <th>Item Name(Raw Material)</th>
            <th>UOM</th>
            <th>Supplier</th>
            <th>Supply date</th>
            <th>Cost Price(SAR)</th>
          </tr>
          <tbody>
            <template
              v-for="(rawMaterialCostData,
              rawMaterialCostIndex) in rawMaterialCostRecords"
            >
              <tr :key="rawMaterialCostIndex + '-RawMaterialData'">
                <!-- <td class="text-left">-</td> -->
                <td
                  class="text-left"
                  :rowspan="rawMaterialCostData.supplierWiseCost.length + 1"
                >
                  {{ rawMaterialCostData.cinema_name }}
                </td>
                <td
                  class="text-left"
                  :rowspan="rawMaterialCostData.supplierWiseCost.length + 1"
                >
                  {{ rawMaterialCostData.item_name }}
                </td>
              </tr>
              <template
                v-for="(supplierData,
                supplierIndex) in rawMaterialCostData.supplierWiseCost"
              >
                <tr :key="supplierIndex + '-SupplierData'">
                  <!-- <td class="text-left">{{ supplierData.cine_name }}</td> -->
                  <td class="text-left">{{ supplierData.uom_unit }}</td>
                  <td class="text-left">{{ supplierData.v_name }}</td>
                  <td class="text-left">
                    {{
                      supplierData.supply_date ? supplierData.supply_date : "-"
                    }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(supplierData.single_rate) }}
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
      <div class="swc-report" v-if="rawMaterialCostRecords.length == 0">
        <table class="swc-report-table">
          <thead class="bg-lightgrey font-weight-bold">
            <!-- <th>Book Name</th> -->
            <th>Branch</th>
            <th>Item Name(Raw Material)</th>
            <th>UOM</th>
            <th>Supplier</th>
            <th>Supply date</th>
            <th>Cost Price(SAR)</th>
          </thead>
          <tbody>
            <tr>
              <td colspan="7">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/ReportsService-v2";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import CinemasService from "@/services/CinemasService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";

  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        fromDate: new Date(),
        toDate: new Date(),
        vendorsData: [],
        rawMaterialCostRecords: [],
        selectedVendor: {
          v_name: "",
        },
      };
    },
    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      this.getCinemaList();
      // if (CinemaObj) {
      //   this.onSelectCinema(CinemaObj);
      // }
    },
    watch: {
      // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      //   if (CinemaObj) {
      //     this.onSelectCinema(CinemaObj);
      //   }
      // }
    },
    mounted() {
      this.getVendorsList();
    },
    methods: {
      moment,
      ExportExcel(type, fn, dl) {
        var elt = this.$refs.exportable_table;
        var wb = XLSX.utils.table_to_book(elt, {
          sheet: `RawMaterialSupplierWise`,
        });
        return dl
          ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
          : XLSX.writeFile(
              wb,
              fn ||
                `RawMaterialSupplierWiseCost-${
                  this.dropDown.selectedCinemaName
                }.${type || "xlsx"}`
            );
      },
      getCinemaList: function() {
        MasterService.GetCinemas()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function(event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.$store.dispatch("selectDropdownCinema", event);
      },
      getVendorsList() {
        let loader = this.$loading.show();

        let payload = {
          tableName: "ms_vendors",
          v_is_active: "Y",
        };
        MasterService.GetActiveList(payload).then((response) => {
          const { data } = response;

          if (data.status && data.Records.length > 0) {
            this.vendorsData = data.Records;
            loader.hide();
          } else {
            this.$toasted.show(data.message);
          }
        });
      },
      getRawMaterialsCostReport(isExcel) {
        this.rawMaterialCostRecords = [];
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          search_value: this.selectedVendor ? this.selectedVendor.v_name : "",
          excel: isExcel,
        };
        ReportsService.GetRawMaterialSupplierWise(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.rawMaterialCostRecords = [...data.Records];
              if (isExcel == "Y") {
                window.open(data.excelPath);
              }
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
    },
  };
</script>

<style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }

  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }

  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }

  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }

  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }

  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }

  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid black;
  }
  .swc-report-table td {
    white-space: nowrap;
  }
  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid black !important;
  }
  .swc_table_header th {
    border: 1px solid black !important;
  }
  .no_border {
    border: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/rawMaterialSupplierWiseReport.vue